import React from 'react';
import { Button } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { RiFileExcel2Fill } from 'react-icons/ri';

function DeliveryUpdateModal() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Button
            size="sm"
            colorScheme="purple"
            variant="outline"
            leftIcon={<RiFileExcel2Fill />}
            onClick={() => navigate('/ModifyOrdersExcel')}
        >
            {t('Modifier par Excel')}
        </Button>
    );
}

export default DeliveryUpdateModal;
